import {useState, useCallback} from 'react';

const useShowMenu = (initialValue = false) => {
  const [isMenuVisible, setIsMenuVisible] = useState(initialValue);

  const onShowMenu = useCallback(() => {
    setIsMenuVisible(visible => !visible);
  }, []);

  const onCloseMenu = useCallback(() => {
    setIsMenuVisible(false);
  }, []);

  return {
    isMenuVisible,
    onShowMenu,
    onCloseMenu,
  };
};

export default useShowMenu;
